import { Component } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";
import Styles from "bundle-text:../styles/_successfulModal.scss";
import SuccessIcon from "../assets/success.svg";

interface SuccessfulModalProps {
  show: boolean;
  onClose: () => void;
  onFinish?: () => void;
}

const SuccessfulModal: Component<SuccessfulModalProps> = (props) => {
  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={100}>
        <HeaderModal title="Connection Successful" onClose={props.onClose} />
        <div class="successful-modal-content">
          <p>
            Your domain/subdomain has been successfully connected. Nameserver
            changes can take up to 48 hours to propagate. Ensure your website is
            published for the propagation to take effect.
          </p>
          <img src={SuccessIcon} alt="Success" />

          <button onClick={props.onFinish}>Ok</button>
        </div>
      </DefaultModal>
    </>
  );
};

export default SuccessfulModal;
